var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBestSellers = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M19 7h4.096a1 1 0 0 1 .994.9l.61 6.1H22.69l-.5-5H19v3a1 1 0 0 1-2 0V9H9v3a1 1 0 1 1-2 0V9H3.81l-1.6 16H13v2H1.104a1 1 0 0 1-.994-1.1l1.8-18a1 1 0 0 1 .994-.9H7v-.698C7 2.834 9.672 0 13 0s6 2.834 6 6.302v.7zm-2 0v-.698C17 3.914 15.197 2 13 2c-2.195 0-4 1.914-4 4.302v.7h8zm6.294 15.12L21 19.828V27a1 1 0 0 1-2 0v-7.172L16.71 22.12a1 1 0 1 1-1.415-1.414l4-4a1 1 0 0 1 1.415 0l4 4a1 1 0 1 1-1.415 1.414"
})));
export default SvgBestSellers;